import React from 'react'
import { Helmet } from "react-helmet-async"; // ✅ ADD THIS
import Banner from '../Components/Banner'
import pattern from '../Assets/careerbannerpattern.png'
import Breadcrumb from '../Components/Breadcrumb'
import NovaCareerAbout from './../Components/Careers/NovaCareerAbout';
import CareerFAQ from '../Components/Careers/CareerFAQ';
import ApplicationForm from './../Components/Careers/ApplicationForm';
import WhatWeOffer from './../Components/Careers/WhatWeOffer';
import { motion } from "framer-motion";

const Careers = () => {

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } }
  };

  // ✅ SCHEMA FOR CAREERS PAGE
  const schema = {
    "@context": "https://schema.org",
    "@graph": [

      {
        "@type": "WebPage",
        "name": "Careers at Nova EduBridge",
        "url": "https://novaedubridge.com/careers",
        "description": "Explore career opportunities at Nova EduBridge. Join our team and help students achieve their study abroad dreams."
      },

      {
        "@type": "Organization",
        "name": "Nova EduBridge",
        "url": "https://novaedubridge.com/",
        "telephone": "+91-9902043004",
        "email": "info@novaedubridge.com",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "addressCountry": "IN"
        }
      },

      {
        "@type": "JobPosting",
        "title": "Study Abroad Counselor",
        "description": "We are looking for passionate study abroad counselors to guide students in their international education journey.",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "Nova EduBridge"
        },
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Bangalore",
            "addressRegion": "Karnataka",
            "addressCountry": "IN"
          }
        },
        "employmentType": "Full-time"
      },

      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How can I apply for a job at Nova EduBridge?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can apply by filling out the application form on our careers page."
            }
          },
          {
            "@type": "Question",
            "name": "What roles are available at Nova EduBridge?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer roles such as study abroad counselors, marketing executives, and support staff."
            }
          },
          {
            "@type": "Question",
            "name": "Where is the job location?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "All roles are based in Bangalore, India."
            }
          }
        ]
      }

    ]
  };

  return (
    <>
      {/* ✅ SCHEMA */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <div>
        {/* Banner */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <Banner
            className='position-relative'
            subtitle="Careers"
             title="Study Abroad Consultancy Careers"
            buttonText="Submit"
            buttonLink="/Contact"
            backgroundImage="/images/career-banner.png"
          />
          <div className='position-absolute pattern'>
            <img src={pattern} alt='pattern' />
          </div>
        </motion.div>

        {/* Breadcrumb */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <Breadcrumb/>
        </motion.div>

        {/* Sections */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <NovaCareerAbout/>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <CareerFAQ/>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <ApplicationForm/>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeUp}>
          <WhatWeOffer/>
        </motion.div>
      </div>
    </>
  )
}

export default Careers
